<template>
  <table class="table table-bordered my-3">
    <thead class="thead">
      <tr>
        <th colspan="3">{{ $t('社内工程') }}</th>
        <th width="84">{{ $t('段取時間') }}</th>
        <th width="84">{{ $t('加工時間') }}</th>
        <th width="84">{{ $t('時間単位') }}</th>
        <th width="84">{{ $t('担当者') }}</th>
        <th width="84">{{ $t('加工合計') }}</th>
        <th width="70"></th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr>
        <td rowspan="5" width="20">
          <button
            type="button"
            class="btn btn-light"
            @click="changeSort('up')"
            :disabled="baseProcess.sort === 1 || baseProcess.sort === 2 && baseProcess.isMaterialPrepare"
          ><font-awesome-icon :icon="['fas','arrow-up']"></font-awesome-icon></button><br>
          {{baseProcess.sort}}<br>
          <button
            type="button"
            class="btn btn-light"
            @click="changeSort('down')"
            :disabled="quantity === baseProcess.sort"
          ><font-awesome-icon :icon="['fas','arrow-down']"></font-awesome-icon></button>
        </td>
        <td rowspan="5" width="100">
          {{ $t(mixinProcessKindDisplay(baseProcess.processKindId)) }}<br v-if="baseProcess.processKindId">
          <button
            type="button"
            class="btn btn-light"
            @click="processKindsModalOpen()"
          >{{ $t('工程区分選択') }}</button>
        </td>
        <td rowspan="5" width="100">
          <select-suggest-process
            :selectedId="baseProcess.processId"
            :additionalParams="{processKindId: baseProcess.processKindId}"
            @selected="onSelectedProcess"
          ></select-suggest-process>
        </td>
        <td>
          <input :value="baseProcess.prepareTime" @input="changeValue($event,'prepareTime','number')" type="number" min="0" class="form-control">
        </td>
        <td>
          <input :value="baseProcess.machiningTime" @input="changeValue($event,'machiningTime','number')" type="number" min="0" class="form-control">
        </td>
        <td>
          <select :value="baseProcess.timeUnit" @change="changeValue($event,'timeUnit','string')" class="form-control">
            <option value="-1">-</option>
            <option v-for="(unit) in timeUnit" :key="unit.value" :value="unit.value">{{ unit.name }}</option>
          </select>
        </td>
        <td>
          <select-suggest-user
            :selectedId="baseProcess.userId"
            :additionalParams="{processKindId: baseProcess.processKindId, processId: baseProcess.processId}"
            @selected="onSelectedUser"
          ></select-suggest-user>
        </td>
        <td>
          {{ totalTime }}
          {{ mixinTimeUnitDisplay(baseProcess.timeUnit) }}
        </td>
        <td rowspan="5">
          <button
            type="button"
            class="btn btn-light wf-50 mb-3"
            @click="copyProcess()"
          >{{ $t('複製') }}</button><br>
          <button
            type="button"
            class="btn btn-light wf-50 mb-3"
            @click="insertProcess()"
          >{{ $t('挿入') }}</button><br>
          <button
            type="button"
            class="btn btn-danger wf-50"
            @click="deleteProcess()"
          >{{ $t('削除') }}</button>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <input :value="baseProcess.jig" @input="changeValue($event,'jig','string')" type="text" class="form-control" :placeholder="$t('治具')">
        </td>
        <td colspan="2">
          <input v-model="baseProcess.tool" @input="changeValue($event,'tool','string')" type="text" class="form-control" :placeholder="$t('ツール/プログラム')">
        </td>
      </tr>
      <tr>
        <td colspan="5">
          <input v-model="baseProcess.note" @input="changeValue($event,'note','string')" type="text" class="form-control" :placeholder="$t('作業内容/申し送り事項')">
        </td>
      </tr>
      <tr>
        <th class="table-active" colspan="5">{{ $t('構成部品') }}</th>
      </tr>
      <tr>
        <td colspan="5" class="text-left">
          <base-process-structure
           v-for="(item, index) in baseProcess.structures" :key="`structure-${index}`"
          class="mb-2"
          ref="baseStructure"
          :structure="item"
          :structures="structures"
          @addStructure="addStructure()"
          @removeStructure="removeStructure($event, index)"
          @changeStructure="changeStructure($event, index)"
          ></base-process-structure>
          <button
            type="button"
            class="btn btn-light"
            @click="addStructure()"
          >{{ $t('追加') }}</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectSuggestUser from '@/components/suggest/user.vue'
import SelectSuggestProcess from '@/components/suggest/process.vue'
import baseProcessStructure from './baseProcessStructure'
export default {
  props: {
    baseProcess: {
      tupe: Object,
      default: () => {},
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    timeUnit: {
      type: Array,
      default: () => [],
    },
    quantity: {
      type: Number,
      default: 0,
    },
    structures: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  components: {baseProcessStructure, SelectSuggestProcess, SelectSuggestUser},
  data() {
    return {
      users: [],
      userSelected: {},
    }
  },
  methods: {
    // 工程区分のモーダルを表示
    processKindsModalOpen() {
      this.$emit('processKindsModalOpen')
    },
    // 標準工程をコピー
    copyProcess() {
      this.$emit('copyProcess')
    },
    // 標準工程を挿入
    insertProcess() {
      this.$emit('insertProcess')
    },
    // 標準工程を削除
    deleteProcess() {
      this.$emit('deleteProcess', this.baseProcess.sort)
    },
    // ソートを変更する処理
    changeSort(direction) {
      this.$emit('changeSort', { sort: this.baseProcess.sort, direction: direction })
    },
    // 値を変更する処理
    changeValue(e, key, type) {
      this.$emit('changeValue', { value: e.target.value, key: key, type: type })
    },
    // 構成部品の値を変更する処理
    changeStructure(e, index) {
      this.$emit('changeStructure', e, index, this.baseProcess.sort)
    },
    // 構成部品を追加
    addStructure() {
      this.$emit('addStructure', { sort: this.baseProcess.sort })
    },
    // 構成部品を削除
    removeStructure(e, index) {
      this.$emit('removeStructure', { sort: this.baseProcess.sort, index: index })
    },
    onSelectedUser(newVal) {
      if (newVal !== null) {
        this.$emit('changeValue', { value: newVal.id, key: 'userId', type: 'number' })
      } else {
        this.$emit('changeValue', { value: null, key: 'userId', type: 'number' })
      }
    },
    onSelectedProcess(newVal) {
      if (newVal !== null) {
        this.$emit('changeValue', { value: newVal.id, key: 'processId', type: 'number' })
        this.$emit('changeValue', { value: newVal.processKindId, key: 'processKindId', type: 'number' })
      } else {
        this.$emit('changeValue', { value: null, key: 'processId', type: 'number' })
      }
      this.$emit('changeValue', { value: null, key: 'userId', type: 'number' })
    },
  },
  computed: {
    totalTime() {
      if (this.isEmpty(this.baseProcess.prepareTime) && this.isEmpty(this.baseProcess.machiningTime)) return '-'
      if (this.isEmpty(this.baseProcess.prepareTime)) return this.baseProcess.machiningTime
      if (this.isEmpty(this.baseProcess.machiningTime)) return this.baseProcess.prepareTime
      return (this.baseProcess.prepareTime + this.baseProcess.machiningTime)
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>
